import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ErrorBox } from "../components/ui";
import { TokelLogo } from "../components/brand";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");

  const submit = useMutation({
    mutationFn: () => api.post("/auth/password-reset/confirm", { token, password }),
  });

  return (
    <div className="auth-page">
      <div className="card auth-card">
        <div className="auth-brand">
          <TokelLogo size={30} />
        </div>
        <h1>Новый пароль</h1>
        <p className="lede">
          Ссылка действует час. После смены пароля все открытые сессии закрываются —
          так и должно быть, если пароль меняют из-за утечки.
        </p>
        {submit.isSuccess ? (
          <p>
            Пароль изменён. <a href="/">Войти</a>
          </p>
        ) : (
          <form
            onSubmit={(event) => {
              event.preventDefault();
              submit.mutate();
            }}
          >
            <div className="field">
              <label htmlFor="new-password">Пароль</label>
              <input
                id="new-password"
                type="password"
                minLength={10}
                required
                autoComplete="new-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
            {submit.error && (
              <div style={{ marginBottom: 12 }}>
                <ErrorBox error={submit.error} />
              </div>
            )}
            <button className="primary" type="submit" disabled={!token || submit.isPending} style={{ width: "100%" }}>
              Сохранить
            </button>
            {!token && <p className="faint" style={{ marginTop: 10 }}>В ссылке нет токена.</p>}
          </form>
        )}
      </div>
    </div>
  );
}
